import React from 'react'

export default function GameFeatures({ contentConfig, config, onPlayVideo }) {
  return (
    <section id="s3" className="swiper-slide game-features">
      <section
        className="flex-1 features-left"
        role="button"
        tabIndex={0}
        aria-label="Play left features video"
        onClick={() => onPlayVideo(contentConfig.left_video)}
        onKeyDown={e => {
          if (e.key === 'Enter') onPlayVideo(contentConfig.left_video)
        }}
      >
        <img
          src={contentConfig.left_image || './images/content_left.png'}
          alt="Left game feature"
          className="content-bg"
        />
        <div className="content-mask">
          <img src="./images/content_mask_left.png" alt="" aria-hidden="true" />
        </div>
        <div className="icon-play" />
        <img
          className="btn-play"
          src={contentConfig.left_btn || `${config.imgBase}play_roles.png`}
          alt="Play"
        />
      </section>

      <section
        className="flex-1 features-middle"
        role="button"
        tabIndex={0}
        aria-label="Play middle features video"
        onClick={() => onPlayVideo(contentConfig.middle_video)}
        onKeyDown={e => {
          if (e.key === 'Enter') onPlayVideo(contentConfig.middle_video)
        }}
      >
        <div className="content-mask">
          <img src="./images/content_mask_middle.png" alt="" aria-hidden="true" />
        </div>
        <div className="icon-play" />
        <img
          className="btn-play"
          src={contentConfig.middle_btn || `${config.imgBase}play_boss.png`}
          alt="Play"
        />
        <img
          src={contentConfig.middle_image || './images/content_middle.png'}
          alt="Middle game feature"
          className="content-bg"
        />
      </section>

      <section
        className="flex-1 features-right"
        role="button"
        tabIndex={0}
        aria-label="Play right features video"
        onClick={() => onPlayVideo(contentConfig.right_video)}
        onKeyDown={e => {
          if (e.key === 'Enter') onPlayVideo(contentConfig.right_video)
        }}
      >
        <div className="content-mask">
          <img src="./images/content_mask_right.png" alt="" aria-hidden="true" />
        </div>
        <div className="icon-play" />
        <img
          className="btn-play"
          src={contentConfig.right_btn || `${config.imgBase}play_weapons.png`}
          alt="Play"
        />
        <img
          src={contentConfig.right_image || './images/content_right.png'}
          alt="Right game feature"
          className="content-bg"
        />
      </section>
    </section>
  )
}
